import React from "react"
import { Container, Left, Right, Countdown } from "./styles"

const AnnouncementBar = ({
  announceElements,
  endTime,
  dropdownAndButtonElement,
  buttonElement,
  secondaryButtonElement,
  dataId,
  subNavButton,
  ...props
}) => (
  <Container data-exp-id={dataId} {...props}>
    <Left hasButton={!!buttonElement} {...props}>
      {announceElements}
    </Left>
    {(!!endTime || buttonElement) && (
      <Right data-experiment-id="buttons" hasSecondaryButton={!!secondaryButtonElement} {...props}>
        {endTime && <Countdown targetDate={endTime} />}
        {buttonElement}
        {secondaryButtonElement}
      </Right>
    )}
    {!buttonElement && subNavButton && (
      <Right data-experiment-id="buttons" {...props}>
        {subNavButton}
      </Right>
    )}
    {dropdownAndButtonElement}
  </Container>
)

export default AnnouncementBar
